import React from 'react'

export const NAME = 'PRODUCT'

export const types = {
  PRODUCT_LIST_REQUEST: `${NAME}/PRODUCT_LIST_REQUEST`,
  PRODUCT_LIST_SUCCESS: `${NAME}/PRODUCT_LIST_SUCCESS`,
  PRODUCT_LIST_FAILURE: `${NAME}/PRODUCT_LIST_FAILURE`,
  PRODUCT_CREATE_REQUEST: `${NAME}/PRODUCT_CREATE_REQUEST`,
  PRODUCT_CREATE_SUCCESS: `${NAME}/PRODUCT_CREATE_SUCCESS`,
  PRODUCT_CREATE_FAILURE: `${NAME}/PRODUCT_CREATE_FAILURE`,
  PRODUCT_EDIT_REQUEST: `${NAME}/PRODUCT_EDIT_REQUEST`,
  PRODUCT_EDIT_SUCCESS: `${NAME}/PRODUCT_EDIT_SUCCESS`,
  PRODUCT_EDIT_FAILURE: `${NAME}/PRODUCT_EDIT_FAILURE`,
  SELECTED_PRODUCT_SET: `${NAME}/SELECTED_PRODUCT_SET`,
  SELECTED_PRODUCT_DROP: `${NAME}/SELECTED_PRODUCT_DROP`
}

export const initialState = {
  productsList: [],
  selected: '',
  tableColumns: [
    {
      name: 'id',
      options: {
        display: 'executed',
        viewColumns: false,
        filter: false
      }
    },
    {
      label: 'Культура',
      name: 'name',
      options: {
        filter: true
      }
    },
    {
      label: 'Площадь посева',
      name: 'sowingArea',
      options: {
        filter: false,
        customBodyRender: value =>  value + " Га"
      }
    },
    {
      label: 'Валовый сбор',
      name: 'grossTax',
      options: {
        filter: false,
        customBodyRender: value =>  value + " Тн"
      }
    },
    {
      label: 'Остаток',
      name: 'remainder',
      options: {
        filter: false,
        customBodyRender: value =>  value + " Тн"
      }
    },
  ],
}
export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        productsList: action.payload
      }
    case types.SELECTED_PRODUCT_SET:
      return {
        ...state,
        selected: action.payload
      }
    case types.SELECTED_PRODUCT_DROP:
      return {
        ...state,
        selected: ''
      }
    default:
      return { ...state }
  }
}